/* =========================================================
   NGR CONFIGURATOR — JAVASCRIPT
   Source section: sections/personalizza-ora.liquid

   Map:
   01 — Cloudinary config
   02 — DOM elements / constants
   03 — Canvas sizing
   04 — File upload / PNG / PDF
   05 — Dimension calculation
   06 — PNG/PDF handling + black/white check
   07 — Canvas drawing / transformations
   08 — Toolbar actions
   09 — Variant / price mapping
   10 — Add to cart
   11 — Success popup
   12 — Color dropdown

   Shopify variant IDs and price steps are in this file.
   Test upload, preview, color selection and add-to-cart after changes.
========================================================= */

(function() {

/* =========================================================
   01. CONFIGURAZIONE CLOUDINARY
========================================================= */
const CLOUDINARY_CLOUD = 'ngrstickerupload';
const CLOUDINARY_PRESET = 'ngr_sticker_upload';

/* =========================================================
   02. ELEMENTI DOM / COSTANTI
========================================================= */
const canvas = document.getElementById('sticker-canvas');
const ctx = canvas.getContext('2d');
const dropZone = document.getElementById('drop-zone');
const fileInput = document.getElementById('file-input');
const widthInput = document.getElementById('width-cm');
const heightDisplay = document.getElementById('height-cm');
const sizeWarning = document.getElementById('size-warning');
const bwWarning = document.getElementById('bw-warning');
const qualityWarning = document.getElementById('quality-warning');
const priceEstimate = document.getElementById('price-estimate');
const summaryDetails = document.getElementById('summary-details');
const configMessage = document.getElementById('ngr-config-message');

const MAX_HEIGHT_CM = 29;
const MAX_WIDTH_CM = 250;
const DEFAULT_CANVAS_HEIGHT = 400;
const MIN_JPEG_CONTENT_LONG_SIDE = 1200;
const RECOMMENDED_JPEG_CONTENT_LONG_SIDE = 1800;
const dpr = window.devicePixelRatio || 1;

let logicalWidth = canvas.parentElement.offsetWidth || 700;
let logicalHeight = DEFAULT_CANVAS_HEIGHT;
let img = null;
let imgRatio = 1;
let currentTool = 'move';
let flippedH = false;
let flippedV = false;
let dragging = false;
let uploadedFileUrl = null;
let imageIsBW = false;
let currentFile = null;
let currentFileKind = null;
let uploadToken = 0;
let fileBlockedForCut = false;

let state = {
  x: 0,
  y: 0,
  scale: 1,
  rotation: 0
};

let lastMouse = {
  x: 0,
  y: 0
};

/* =========================================================
   03. UTILITY
========================================================= */
function fmt(n) {
  return Math.round(n * 10) / 10 + '';
}

function setCartButtonDefault(btn) {
  btn.disabled = false;
  btn.style.opacity = '1';
  btn.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="9" cy="21" r="1"/>
      <circle cx="20" cy="21" r="1"/>
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
    </svg>
    Aggiungi al carrello
  `;
}

function setCartButtonLoading(btn) {
  btn.disabled = true;
  btn.style.opacity = '0.6';
  btn.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M5 22h14"/>
      <path d="M5 2h14"/>
      <path d="M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22"/>
      <path d="M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2"/>
    </svg>
    Caricamento file...
  `;
}

function setCartButtonBlocked(btn) {
  btn.disabled = true;
  btn.style.opacity = '0.55';
  btn.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <path d="m15 9-6 6"/>
      <path d="m9 9 6 6"/>
    </svg>
    File non adatto al taglio
  `;
}


/* =========================================================
   03B. AUTO-CROP AREA GRAFICA / SFONDO CHIARO
========================================================= */
function sampleCornerBackground(data, width, height) {
  const sampleSize = Math.max(2, Math.min(12, Math.floor(Math.min(width, height) * 0.025)));
  const points = [
    { x0: 0, y0: 0 },
    { x0: width - sampleSize, y0: 0 },
    { x0: 0, y0: height - sampleSize },
    { x0: width - sampleSize, y0: height - sampleSize }
  ];

  let r = 0;
  let g = 0;
  let b = 0;
  let a = 0;
  let count = 0;
  let transparentCount = 0;

  points.forEach(function(point) {
    for (let y = point.y0; y < point.y0 + sampleSize; y++) {
      for (let x = point.x0; x < point.x0 + sampleSize; x++) {
        const i = (y * width + x) * 4;
        const alpha = data[i + 3];

        if (alpha < 24) {
          transparentCount++;
          continue;
        }

        r += data[i];
        g += data[i + 1];
        b += data[i + 2];
        a += alpha;
        count++;
      }
    }
  });

  if (!count) {
    return {
      transparent: true,
      light: false,
      r: 255,
      g: 255,
      b: 255,
      a: 0
    };
  }

  const bg = {
    transparent: transparentCount > count * 1.5,
    r: r / count,
    g: g / count,
    b: b / count,
    a: a / count
  };

  const brightness = (bg.r + bg.g + bg.b) / 3;
  const saturation = Math.max(bg.r, bg.g, bg.b) - Math.min(bg.r, bg.g, bg.b);

  bg.light = brightness > 232 && saturation < 28;

  return bg;
}

function isBackgroundPixel(r, g, b, a, bg) {
  if (a < 24) return true;

  const brightness = (r + g + b) / 3;
  const saturation = Math.max(r, g, b) - Math.min(r, g, b);
  const aggressiveJpgCleanup = currentFileKind === 'jpg';

  if (bg && !bg.transparent && bg.a > 32) {
    const distance = Math.sqrt(
      Math.pow(r - bg.r, 2) +
      Math.pow(g - bg.g, 2) +
      Math.pow(b - bg.b, 2)
    );

    // JPG/JPEG: pulizia più forte di sfondi pieni, mockup e immagini da internet.
    if (aggressiveJpgCleanup && distance < 64) return true;

    // PNG: resta più conservativo. Rimuove solo sfondi chiari/quasi bianchi.
    if (bg.light && brightness > 226 && saturation < 44 && distance < 82) return true;
  }

  return false;
}

function shouldDiscardLightPixel(r, g, b, a, aggressiveCleanup) {
  if (a < 24) return true;

  const brightness = (r + g + b) / 3;
  const saturation = Math.max(r, g, b) - Math.min(r, g, b);

  if (aggressiveCleanup) {
    // Solo JPG/JPEG: soglia più aggressiva contro grigi chiari/medi e segni deboli
    // tipici di watermark, canvas, mockup o artefatti da compressione.
    if (brightness > 236) return true;
    if (saturation < 58 && brightness > 122) return true;
    if (saturation < 34 && brightness > 96) return true;
    return false;
  }

  // PNG: soglia più prudente per non cancellare dettagli preparati volutamente.
  if (brightness > 236) return true;
  if (saturation < 46 && brightness > 214) return true;

  return false;
}

function detectContentBoundsFromCanvas(sourceCanvas) {
  const width = sourceCanvas.width;
  const height = sourceCanvas.height;
  const sourceCtx = sourceCanvas.getContext('2d');
  const imageData = sourceCtx.getImageData(0, 0, width, height);
  const data = imageData.data;
  const bg = sampleCornerBackground(data, width, height);

  let minX = width;
  let minY = height;
  let maxX = -1;
  let maxY = -1;

  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const i = (y * width + x) * 4;
      const r = data[i];
      const g = data[i + 1];
      const b = data[i + 2];
      const a = data[i + 3];

      if (isBackgroundPixel(r, g, b, a, bg)) continue;

      if (x < minX) minX = x;
      if (y < minY) minY = y;
      if (x > maxX) maxX = x;
      if (y > maxY) maxY = y;
    }
  }

  if (maxX < minX || maxY < minY) {
    return {
      x: 0,
      y: 0,
      width: width,
      height: height,
      bg: bg,
      cropped: false
    };
  }

  const contentW = maxX - minX + 1;
  const contentH = maxY - minY + 1;
  const padding = Math.max(2, Math.min(18, Math.round(Math.max(contentW, contentH) * 0.025)));

  minX = Math.max(0, minX - padding);
  minY = Math.max(0, minY - padding);
  maxX = Math.min(width - 1, maxX + padding);
  maxY = Math.min(height - 1, maxY + padding);

  const finalW = maxX - minX + 1;
  const finalH = maxY - minY + 1;

  return {
    x: minX,
    y: minY,
    width: finalW,
    height: finalH,
    bg: bg,
    cropped: finalW < width || finalH < height
  };
}

function buildCanvasFromImage(image) {
  const sourceCanvas = document.createElement('canvas');
  sourceCanvas.width = image.naturalWidth || image.width;
  sourceCanvas.height = image.naturalHeight || image.height;

  const sourceCtx = sourceCanvas.getContext('2d');
  sourceCtx.drawImage(image, 0, 0, sourceCanvas.width, sourceCanvas.height);

  return sourceCanvas;
}

function cropCanvasToContent(sourceCanvas, makeLightBackgroundTransparent) {
  const bounds = detectContentBoundsFromCanvas(sourceCanvas);
  const croppedCanvas = document.createElement('canvas');
  croppedCanvas.width = Math.max(1, bounds.width);
  croppedCanvas.height = Math.max(1, bounds.height);

  const croppedCtx = croppedCanvas.getContext('2d');
  croppedCtx.drawImage(
    sourceCanvas,
    bounds.x,
    bounds.y,
    bounds.width,
    bounds.height,
    0,
    0,
    bounds.width,
    bounds.height
  );

  if (makeLightBackgroundTransparent && bounds.bg && !bounds.bg.transparent) {
    const imageData = croppedCtx.getImageData(0, 0, croppedCanvas.width, croppedCanvas.height);
    const data = imageData.data;

    for (let i = 0; i < data.length; i += 4) {
      if (isBackgroundPixel(data[i], data[i + 1], data[i + 2], data[i + 3], bounds.bg)) {
        data[i] = 0;
        data[i + 1] = 0;
        data[i + 2] = 0;
        data[i + 3] = 0;
      }
    }

    croppedCtx.putImageData(imageData, 0, 0);
  }

  return {
    canvas: croppedCanvas,
    bounds: bounds
  };
}

function prepareImageForConfigurator(image, callback) {
  const sourceCanvas = buildCanvasFromImage(image);
  const prepared = cropCanvasToContent(sourceCanvas, true);
  const preparedImage = new Image();

  preparedImage.onload = function() {
    callback(preparedImage, prepared.canvas, prepared.bounds);
  };

  preparedImage.onerror = function() {
    callback(image, sourceCanvas, { cropped: false });
  };

  preparedImage.src = prepared.canvas.toDataURL('image/png');
}

function canvasToPngFile(sourceCanvas, fileName, callback) {
  sourceCanvas.toBlob(function(blob) {
    if (!blob) {
      alert('Non sono riuscito a preparare il file. Prova con un altro PNG.');
      return;
    }

    callback(new File([blob], fileName, { type: 'image/png' }), URL.createObjectURL(blob));
  }, 'image/png');
}

function getPreparedFileName(file) {
  const baseName = (file.name || 'adesivo').replace(/\.[^.]+$/, '');
  return baseName + '_preparato.png';
}

function hideRasterQualityWarning() {
  if (!qualityWarning) return;
  qualityWarning.style.display = 'none';
  qualityWarning.innerHTML = '';
}

function getRasterLongSide(bounds) {
  if (!bounds) return 0;
  return Math.max(bounds.width || 0, bounds.height || 0);
}

function isJpegQualityTooLow(bounds) {
  const longSide = getRasterLongSide(bounds);
  return longSide > 0 && longSide < MIN_JPEG_CONTENT_LONG_SIDE;
}

function rejectLowQualityJpeg(bounds) {
  const longSide = getRasterLongSide(bounds);
  const message = 'JPG/JPEG troppo piccolo. La grafica rilevata è circa ' + longSide + ' px sul lato lungo. Carica un JPG/JPEG da almeno ' + MIN_JPEG_CONTENT_LONG_SIDE + ' px sul lato lungo, oppure usa un PNG grande o un PDF vettoriale.';

  alert(message);

  img = null;
  uploadedFileUrl = null;
  imageIsBW = false;
  fileBlockedForCut = false;
  currentFile = null;
  currentFileKind = null;
  fileBlockedForCut = false;
  uploadToken++;
  fileInput.value = '';
  dropZone.classList.remove('ngr-hidden');
  bwWarning.style.display = 'none';
  hideRasterQualityWarning();
  heightDisplay.value = 'auto';
  setCartButtonDefault(document.getElementById('add-to-cart-btn'));
  drawCanvas();
  updateSummary();
}

function showRasterQualityWarning(kind, bounds) {
  if (!qualityWarning || !bounds) return;

  const longSide = getRasterLongSide(bounds);
  let level = null;
  let title = '';
  let text = '';

  if (kind === 'jpg') {
    if (longSide > 0 && longSide < RECOMMENDED_JPEG_CONTENT_LONG_SIDE) {
      level = 'soft';
      title = 'Qualità JPG accettabile, ma migliorabile';
      text = 'Per un risultato più pulito consigliamo un JPG/JPEG da almeno ' + RECOMMENDED_JPEG_CONTENT_LONG_SIDE + ' px sul lato lungo, oppure un PNG grande o un PDF vettoriale.';
    } else {
      hideRasterQualityWarning();
      return;
    }
  } else if (longSide > 0 && longSide < 500) {
    level = 'strong';
    title = 'Qualità molto bassa rilevata';
    text = 'La grafica potrebbe risultare poco definita. Se possibile, carica un file più grande o un PDF.';
  } else if (longSide > 0 && longSide < 800) {
    level = 'soft';
    title = 'Qualità file da verificare';
    text = 'Per un risultato migliore consigliamo un PNG/JPG più grande o un PDF vettoriale.';
  } else {
    hideRasterQualityWarning();
    return;
  }

  qualityWarning.className = 'ngr-quality-warning ngr-quality-warning--' + level;
  qualityWarning.innerHTML = '<strong>' + title + '</strong><span>' + text + '</span>';
  qualityWarning.style.display = 'flex';
}

function analyzeRasterCutSuitability(sourceCanvas, kind) {
  if (!sourceCanvas || (kind !== 'png' && kind !== 'jpg')) {
    return { ok: true };
  }

  const maxSide = 220;
  const scale = Math.min(1, maxSide / Math.max(sourceCanvas.width, sourceCanvas.height));
  const sampleCanvas = document.createElement('canvas');
  sampleCanvas.width = Math.max(1, Math.round(sourceCanvas.width * scale));
  sampleCanvas.height = Math.max(1, Math.round(sourceCanvas.height * scale));

  const sampleCtx = sampleCanvas.getContext('2d');
  sampleCtx.drawImage(sourceCanvas, 0, 0, sampleCanvas.width, sampleCanvas.height);

  const imageData = sampleCtx.getImageData(0, 0, sampleCanvas.width, sampleCanvas.height);
  const data = imageData.data;

  let visible = 0;
  let midtone = 0;
  let colorPixels = 0;
  let neutralMid = 0;
  let semiLight = 0;
  const colorBins = Object.create(null);
  const lumaBins = Object.create(null);

  for (let i = 0; i < data.length; i += 4) {
    const alpha = data[i + 3];
    if (alpha < 40) continue;

    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];
    const brightness = (r + g + b) / 3;
    const saturation = Math.max(r, g, b) - Math.min(r, g, b);

    visible++;

    const colorKey = (r >> 4) + '_' + (g >> 4) + '_' + (b >> 4);
    colorBins[colorKey] = true;
    lumaBins[Math.round(brightness / 4)] = true;

    if (brightness > 24 && brightness < 232) midtone++;
    if (saturation > 32) colorPixels++;
    if (saturation < 42 && brightness > 54 && brightness < 224) neutralMid++;
    if (brightness > 150 && brightness < 238 && saturation < 74) semiLight++;
  }

  if (visible < 80) return { ok: true };

  const uniqueColors = Object.keys(colorBins).length;
  const uniqueLuma = Object.keys(lumaBins).length;
  const midtoneRatio = midtone / visible;
  const colorRatio = colorPixels / visible;
  const neutralMidRatio = neutralMid / visible;
  const semiLightRatio = semiLight / visible;

  // Antialias e compressione leggera sono normali. Blocchiamo solo file con
  // molte sfumature/mezzi toni o comportamento chiaramente fotografico.
  const looksGradient =
    (uniqueLuma > 52 && midtoneRatio > 0.46 && uniqueColors > 70) ||
    (uniqueColors > 130 && midtoneRatio > 0.34) ||
    (uniqueColors > 90 && colorRatio > 0.62 && midtoneRatio > 0.34);

  const looksPhotoOrMockup =
    (uniqueColors > 170) ||
    (uniqueColors > 105 && neutralMidRatio > 0.30) ||
    (kind === 'jpg' && uniqueColors > 78 && semiLightRatio > 0.36 && midtoneRatio > 0.42);

  if (looksGradient || looksPhotoOrMockup) {
    return {
      ok: false,
      uniqueColors: uniqueColors,
      uniqueLuma: uniqueLuma,
      midtoneRatio: midtoneRatio,
      colorRatio: colorRatio,
      reason: looksPhotoOrMockup ? 'photo' : 'gradient'
    };
  }

  return { ok: true };
}

function showCutFileBlocked(analysis) {
  fileBlockedForCut = true;
  uploadedFileUrl = null;
  imageIsBW = false;

  bwWarning.style.display = 'block';
  bwWarning.className = 'ngr-success ngr-error-red ngr-cut-warning';
  bwWarning.innerHTML = `
    <span class="ngr-success__line">
      <svg
        class="ngr-error-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.3 13.29-1.41 1.41L12 13.41l-2.89 2.89-1.41-1.41L10.59 12 7.7 9.11 9.11 7.7 12 10.59 14.89 7.7l1.41 1.41L13.41 12l2.89 2.89z"/>
      </svg>
      <span class="ngr-success__text">
        <span class="ngr-success__title">File non adatto al taglio</span>
        <span class="ngr-desktop-dash">—</span>
        <span class="ngr-success__subtitle">Contiene sfumature, ombre o dettagli fotografici</span>
      </span>
    </span>
  `;

  hideRasterQualityWarning();
  setCartButtonBlocked(document.getElementById('add-to-cart-btn'));
}

function analyzeMonochromeCanvas(sourceCanvas) {
  const workCtx = sourceCanvas.getContext('2d');
  const imageData = workCtx.getImageData(0, 0, sourceCanvas.width, sourceCanvas.height);
  const data = imageData.data;

  let dark = 0;
  let light = 0;

  for (let i = 0; i < data.length; i += 4) {
    const alpha = data[i + 3];
    if (alpha < 24) continue;

    const brightness = (data[i] + data[i + 1] + data[i + 2]) / 3;

    if (brightness <= 176) {
      dark++;
    } else {
      light++;
    }
  }

  let mode = 'dark-only';

  if (light > 0 && dark === 0) {
    mode = 'light-only';
  } else if (light > 0 && dark > 0) {
    // Quando il file contiene sia nero che bianco,
    // assumiamo che il nero sia la grafica e il bianco sia area da svuotare.
    mode = 'dark-only';
  }

  return {
    dark: dark,
    light: light,
    mode: mode,
    mixed: dark > 0 && light > 0
  };
}

function normalizeMonochromeCanvas(sourceCanvas) {
  const outCanvas = document.createElement('canvas');
  outCanvas.width = sourceCanvas.width;
  outCanvas.height = sourceCanvas.height;

  const outCtx = outCanvas.getContext('2d');
  outCtx.drawImage(sourceCanvas, 0, 0);

  const imageData = outCtx.getImageData(0, 0, outCanvas.width, outCanvas.height);
  const data = imageData.data;
  const analysis = analyzeMonochromeCanvas(sourceCanvas);
  const keepDark = analysis.mode !== 'light-only';

  for (let i = 0; i < data.length; i += 4) {
    const alpha = data[i + 3];

    if (alpha < 20) {
      data[i] = 0;
      data[i + 1] = 0;
      data[i + 2] = 0;
      data[i + 3] = 0;
      continue;
    }

    const brightness = (data[i] + data[i + 1] + data[i + 2]) / 3;

    if (keepDark) {
      if (brightness <= 176) {
        data[i] = 0;
        data[i + 1] = 0;
        data[i + 2] = 0;
      } else {
        data[i] = 0;
        data[i + 1] = 0;
        data[i + 2] = 0;
        data[i + 3] = 0;
      }
    } else {
      if (brightness > 176) {
        data[i] = 255;
        data[i + 1] = 255;
        data[i + 2] = 255;
      } else {
        data[i] = 0;
        data[i + 1] = 0;
        data[i + 2] = 0;
        data[i + 3] = 0;
      }
    }
  }

  outCtx.putImageData(imageData, 0, 0);

  return {
    canvas: outCanvas,
    analysis: analysis
  };
}

function buildPreparedMonochromeFile(sourceCanvas, originalFile, callback) {
  const normalized = normalizeMonochromeCanvas(sourceCanvas);
  canvasToPngFile(normalized.canvas, getPreparedFileName(originalFile), function(file, previewUrl) {
    callback(file, previewUrl, normalized.analysis);
  });
}

/* =========================================================
   04. CANVAS SETUP / RESIZE
========================================================= */
function resizeCanvas(lw, lh) {
  logicalWidth = lw;
  logicalHeight = lh;

  canvas.width = Math.round(lw * dpr);
  canvas.height = Math.round(lh * dpr);
  canvas.style.width = lw + 'px';
  canvas.style.height = lh + 'px';

  ctx.setTransform(1, 0, 0, 1, 0, 0);
  ctx.scale(dpr, dpr);
}

function handleWindowResize() {
  const newW = canvas.parentElement.offsetWidth || 700;

  if (img) {
    const wCm = parseFloat(widthInput.value) || 10;
    const hCm = wCm * imgRatio;
    const newH = Math.max(Math.round((hCm / wCm) * newW), 200);

    resizeCanvas(newW, newH);
    state.x = newW / 2;
    state.y = newH / 2;
  } else {
    resizeCanvas(newW, logicalHeight);
  }

  drawCanvas();
}

resizeCanvas(logicalWidth, logicalHeight);
drawCanvas();
window.addEventListener('resize', handleWindowResize);

/* =========================================================
   05. FILE UPLOAD / DRAG & DROP
========================================================= */
function getFileKind(file) {
  if (!file) return null;

  const name = (file.name || '').toLowerCase();

  if (file.type === 'application/pdf' || name.endsWith('.pdf')) return 'pdf';
  if (file.type === 'image/png' || name.endsWith('.png')) return 'png';
  if (file.type === 'image/jpeg' || name.endsWith('.jpg') || name.endsWith('.jpeg')) return 'jpg';

  return null;
}

function isValidFile(file) {
  return getFileKind(file) === 'png' || getFileKind(file) === 'jpg' || getFileKind(file) === 'pdf';
}

function handleSelectedFile(file) {
  if (!file) return;

  if (!isValidFile(file)) {
    alert('Formato non supportato. Carica un file PNG, JPG, JPEG o PDF.');
    fileInput.value = '';
    return;
  }

  loadFile(file);
}

dropZone.addEventListener('dragover', function(e) {
  e.preventDefault();
  dropZone.classList.add('dragover');
});

dropZone.addEventListener('dragleave', function() {
  dropZone.classList.remove('dragover');
});

dropZone.addEventListener('drop', function(e) {
  e.preventDefault();
  dropZone.classList.remove('dragover');
  handleSelectedFile(e.dataTransfer.files[0]);
});

fileInput.addEventListener('change', function(e) {
  handleSelectedFile(e.target.files[0]);
});

/* =========================================================
   06. LOAD FILE + CLOUDINARY UPLOAD
========================================================= */
function loadFile(file) {
  clearConfigMessage();
  uploadedFileUrl = null;
  imageIsBW = false;
  fileBlockedForCut = false;
  currentFile = file;
  currentFileKind = getFileKind(file);
  uploadToken++;

  bwWarning.style.display = 'none';
  hideRasterQualityWarning();
  setCartButtonDefault(document.getElementById('add-to-cart-btn'));

  loadFilePreview(file);

  if (currentFileKind === 'pdf') {
    uploadFileToCloudinary(file);
  }
}

function loadFilePreview(file) {
  const reader = new FileReader();

  reader.onload = function(ev) {
    const image = new Image();

    image.onload = function() {
      prepareImageForConfigurator(image, function(preparedImage, preparedCanvas, preparedBounds) {
        if (currentFileKind === 'jpg' && isJpegQualityTooLow(preparedBounds)) {
          rejectLowQualityJpeg(preparedBounds);
          return;
        }

        img = preparedImage;
        dropZone.classList.add('ngr-hidden');
        imgRatio = preparedImage.naturalHeight / preparedImage.naturalWidth;
        flippedH = false;
        flippedV = false;

        updateCanvasHeight();

        if (currentFileKind === 'png' || currentFileKind === 'jpg') {
          const cutAnalysis = analyzeRasterCutSuitability(preparedCanvas, currentFileKind);

          if (!cutAnalysis.ok) {
            showCutFileBlocked(cutAnalysis);
            drawCanvas();
            return;
          }

          showRasterQualityWarning(currentFileKind, preparedBounds);
        }

        if (currentFileKind === 'pdf') {
          markPdfAccepted();
        } else {
          const isMonochrome = checkBW(preparedImage);

          if (isMonochrome) {
            if (preparedCanvas) {
              buildPreparedMonochromeFile(preparedCanvas, file, function(preparedFile, previewUrl) {
                const preparedMonoImage = new Image();

                preparedMonoImage.onload = function() {
                  img = preparedMonoImage;
                  currentFile = preparedFile;
                  currentFileKind = 'png';
                  imageIsBW = true;
                  fileBlockedForCut = false;
                  uploadedFileUrl = null;
                  imgRatio = preparedMonoImage.naturalHeight / preparedMonoImage.naturalWidth;

                  updateCanvasHeight();
                  drawCanvas();
                  uploadFileToCloudinary(preparedFile);
                };

                preparedMonoImage.onerror = function() {
                  currentFile = preparedFile;
                  currentFileKind = 'png';
                  imageIsBW = true;
                  uploadFileToCloudinary(preparedFile);
                };

                preparedMonoImage.src = previewUrl;
              });
            } else {
              imageIsBW = true;
              uploadFileToCloudinary(file);
            }
          }
        }

        drawCanvas();
      });
    };

    image.onerror = function() {
      if (currentFileKind === 'pdf') {
        createPdfPlaceholder(file);
        return;
      }

      alert('Non sono riuscito a leggere l’immagine. Prova con un altro file PNG o JPG.');
      fileInput.value = '';
      setCartButtonDefault(document.getElementById('add-to-cart-btn'));
    };

    image.src = ev.target.result;
  };

  reader.readAsDataURL(file);
}

function createPdfPlaceholder(file) {
  const placeholder = document.createElement('canvas');
  placeholder.width = 1000;
  placeholder.height = 650;

  const pctx = placeholder.getContext('2d');
  pctx.fillStyle = '#111111';
  pctx.fillRect(0, 0, placeholder.width, placeholder.height);

  pctx.fillStyle = 'rgba(255,255,255,.08)';
  pctx.fillRect(40, 40, placeholder.width - 80, placeholder.height - 80);

  pctx.fillStyle = '#ffffff';
  pctx.font = 'bold 92px -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif';
  pctx.textAlign = 'center';
  pctx.textBaseline = 'middle';
  pctx.fillText('PDF', placeholder.width / 2, placeholder.height / 2 - 30);

  pctx.fillStyle = 'rgba(255,255,255,.62)';
  pctx.font = '34px -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif';
  pctx.fillText('File verificato prima della produzione', placeholder.width / 2, placeholder.height / 2 + 55);

  const placeholderImage = new Image();

  placeholderImage.onload = function() {
    img = placeholderImage;
    dropZone.classList.add('ngr-hidden');
    imgRatio = placeholderImage.naturalHeight / placeholderImage.naturalWidth;
    flippedH = false;
    flippedV = false;

    updateCanvasHeight();
    markPdfAccepted();
    drawCanvas();
  };

  placeholderImage.src = placeholder.toDataURL('image/png');
}

function markPdfAccepted() {
  fileBlockedForCut = false;
  imageIsBW = true;

  bwWarning.style.display = 'block';
  bwWarning.className = 'ngr-success ngr-pdf-ok';
  bwWarning.innerHTML = `
    <span class="ngr-success__line">
      <span class="ngr-success__icon"></span>
      <span class="ngr-success__text">
        <span class="ngr-success__title">PDF caricato correttamente</span>
        <span class="ngr-desktop-dash">—</span>
        <span class="ngr-success__subtitle">Verifica prima della produzione</span>
      </span>
    </span>
  `;
}

function uploadFileToCloudinary(file) {
  const btn = document.getElementById('add-to-cart-btn');
  const timestamp = Date.now();
  const token = ++uploadToken;
  const safeName = (file.name || 'file').replace(/\.[^.]+$/, '');
  const publicId = safeName + '_' + timestamp;

  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', CLOUDINARY_PRESET);
  formData.append('folder', 'ngr-stickers');
  formData.append('public_id', publicId);

  setCartButtonLoading(btn);

  fetch('https://api.cloudinary.com/v1_1/' + CLOUDINARY_CLOUD + '/auto/upload', {
    method: 'POST',
    body: formData
  })
  .then(function(r) {
    return r.json();
  })
  .then(function(data) {
    if (token !== uploadToken) return;

    if (data.secure_url) {
      uploadedFileUrl = data.secure_url;
      setCartButtonDefault(btn);
    } else {
      alert('Non sono riuscito a caricare il file. Riprova tra qualche secondo.');
      setCartButtonDefault(btn);
    }
  })
  .catch(function() {
    if (token !== uploadToken) return;

    alert('Errore di rete durante il caricamento. Controlla la connessione e riprova.');
    setCartButtonDefault(btn);
  });
}

/* =========================================================
   07. DIMENSIONI
========================================================= */
function updateCanvasHeight() {
  if (!img) return;

  let wCm = parseFloat(widthInput.value) || 10;
  let hCm = wCm * imgRatio;

  sizeWarning.style.display = 'none';

  if (hCm > MAX_HEIGHT_CM) {
    wCm = MAX_HEIGHT_CM / imgRatio;
    hCm = MAX_HEIGHT_CM;
    widthInput.value = fmt(wCm);
    sizeWarning.textContent = `Larghezza ridotta a ${fmt(wCm)} cm per rispettare il limite di ${MAX_HEIGHT_CM} cm di altezza.`;
    sizeWarning.style.display = 'block';
  }

  if (wCm > MAX_WIDTH_CM) {
    wCm = MAX_WIDTH_CM;
    hCm = wCm * imgRatio;
    widthInput.value = MAX_WIDTH_CM;
  }

  heightDisplay.value = fmt(hCm);

  const newH = Math.max(Math.round((hCm / wCm) * logicalWidth), 200);
  resizeCanvas(logicalWidth, newH);

  state.x = logicalWidth / 2;
  state.y = newH / 2;

  drawCanvas();
  updateSummary();
}

function updateWidthFromHeight() {
  if (!img) return;

  let hCm = parseFloat(this.value);
  if (!hCm || hCm <= 0) return;

  if (hCm > MAX_HEIGHT_CM) {
    hCm = MAX_HEIGHT_CM;
    this.value = MAX_HEIGHT_CM;
  }

  let wCm = hCm / imgRatio;
  if (wCm > MAX_WIDTH_CM) wCm = MAX_WIDTH_CM;

  widthInput.value = fmt(wCm);

  const newH = Math.max(Math.round((hCm / wCm) * logicalWidth), 200);
  resizeCanvas(logicalWidth, newH);

  state.x = logicalWidth / 2;
  state.y = newH / 2;

  drawCanvas();
  updateSummary();
}

widthInput.addEventListener('input', updateCanvasHeight);
heightDisplay.addEventListener('input', updateWidthFromHeight);

/* =========================================================
   08. RILEVAMENTO BIANCO/NERO
========================================================= */
function checkBW(image) {
  const offscreen = document.createElement('canvas');
  offscreen.width = Math.min(image.naturalWidth, 160);
  offscreen.height = Math.min(image.naturalHeight, 160);

  const octx = offscreen.getContext('2d');
  octx.drawImage(image, 0, 0, offscreen.width, offscreen.height);

  const data = octx.getImageData(0, 0, offscreen.width, offscreen.height).data;

  let checkedPixels = 0;
  let colorPixels = 0;

  for (let i = 0; i < data.length; i += 4) {
    const alpha = data[i + 3];
    if (alpha < 40) continue;

    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);

    if (max - min > 22) {
      colorPixels++;
    }

    checkedPixels++;
  }

  const colorRatio = checkedPixels ? colorPixels / checkedPixels : 0;
  const isMonochrome = colorRatio <= 0.03;

  bwWarning.style.display = 'block';

  if (isMonochrome) {
    imageIsBW = true;

    bwWarning.className = 'ngr-success';

    bwWarning.innerHTML = `
      <span class="ngr-success__line">
        <span class="ngr-success__icon"></span>
        <span class="ngr-success__text">
          <span class="ngr-success__title">File monocromatico rilevato</span>
          <span class="ngr-desktop-dash">—</span>
          <span class="ngr-success__subtitle">Pronto per il taglio</span>
        </span>
      </span>
    `;

    return true;
  }

  imageIsBW = false;
  fileBlockedForCut = false;
  uploadedFileUrl = null;

  bwWarning.className = 'ngr-success ngr-error-red ngr-mono-warning';

  bwWarning.innerHTML = `
    <span class="ngr-success__line">
      <svg
        class="ngr-error-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.3 13.29-1.41 1.41L12 13.41l-2.89 2.89-1.41-1.41L10.59 12 7.7 9.11 9.11 7.7 12 10.59 14.89 7.7l1.41 1.41L13.41 12l2.89 2.89z"/>
      </svg>
      <span class="ngr-success__text">
        <span class="ngr-success__title">File a colori rilevato</span>
        <span class="ngr-desktop-dash">—</span>
        <span class="ngr-success__subtitle">Converti il file per procedere</span>
      </span>
    </span>

    <button type="button" id="ngr-mono-convert-btn" class="ngr-mono-convert-btn" onclick="convertToMonochrome()">
      Rendi monocromatico
    </button>
  `;

  return false;
}

function getMonochromeFileName(file) {
  const baseName = (file.name || 'adesivo').replace(/\.[^.]+$/, '');
  return baseName + '_monocromatico.png';
}

function buildMonochromeFile(image, originalFile, callback) {
  const sourceCanvas = buildCanvasFromImage(image);
  const prepared = cropCanvasToContent(sourceCanvas, true);
  const offscreen = prepared.canvas;
  const octx = offscreen.getContext('2d');
  const imageData = octx.getImageData(0, 0, offscreen.width, offscreen.height);
  const data = imageData.data;
  const bg = prepared.bounds && prepared.bounds.bg ? prepared.bounds.bg : null;
  const aggressiveCleanup = currentFileKind === 'jpg';

  for (let i = 0; i < data.length; i += 4) {
    const alpha = data[i + 3];

    if (alpha < 20) {
      data[i] = 0;
      data[i + 1] = 0;
      data[i + 2] = 0;
      data[i + 3] = 0;
      continue;
    }

    if (bg && !bg.transparent && isBackgroundPixel(data[i], data[i + 1], data[i + 2], alpha, bg)) {
      data[i] = 0;
      data[i + 1] = 0;
      data[i + 2] = 0;
      data[i + 3] = 0;
      continue;
    }

    if (shouldDiscardLightPixel(data[i], data[i + 1], data[i + 2], alpha, aggressiveCleanup)) {
      data[i] = 0;
      data[i + 1] = 0;
      data[i + 2] = 0;
      data[i + 3] = 0;
      continue;
    }

    data[i] = 0;
    data[i + 1] = 0;
    data[i + 2] = 0;
  }

  octx.putImageData(imageData, 0, 0);
  canvasToPngFile(offscreen, getMonochromeFileName(originalFile), callback);
}

window.convertToMonochrome = function() {
  if (!img || !currentFile || (currentFileKind !== 'png' && currentFileKind !== 'jpg')) {
    alert('La conversione automatica è disponibile solo per file PNG o JPG.');
    return;
  }

  const convertBtn = document.getElementById('ngr-mono-convert-btn');

  if (convertBtn) {
    convertBtn.disabled = true;
    convertBtn.textContent = 'Conversione...';
  }

  buildMonochromeFile(img, currentFile, function(convertedFile, previewUrl) {
    const convertedImage = new Image();

    convertedImage.onload = function() {
      img = convertedImage;
      currentFile = convertedFile;
      currentFileKind = 'png';
      imageIsBW = true;
      fileBlockedForCut = false;
      uploadedFileUrl = null;
      imgRatio = convertedImage.naturalHeight / convertedImage.naturalWidth;

      updateCanvasHeight();
      showMonochromeConverted();
      uploadFileToCloudinary(convertedFile);
      drawCanvas();
    };

    convertedImage.onerror = function() {
      alert('Non sono riuscito a generare l’anteprima monocromatica. Prova con un altro PNG.');
      setCartButtonDefault(document.getElementById('add-to-cart-btn'));
    };

    convertedImage.src = previewUrl;
  });
};

function showMonochromeConverted() {
  bwWarning.style.display = 'block';
  bwWarning.className = 'ngr-success';
  bwWarning.innerHTML = `
    <span class="ngr-success__line">
      <span class="ngr-success__icon"></span>
      <span class="ngr-success__text">
        <span class="ngr-success__title">File convertito in monocromatico</span>
        <span class="ngr-desktop-dash">—</span>
        <span class="ngr-success__subtitle">Pronto per il taglio</span>
      </span>
    </span>
  `;
}

function getInvertedFileName(file) {
  const baseName = (file.name || 'adesivo').replace(/\.[^.]+$/, '');
  return baseName + '_invertito.png';
}

function isDarkBackgroundPixel(r, g, b, a, bg) {
  if (!bg || bg.transparent || a < 24) return false;

  const bgBrightness = (bg.r + bg.g + bg.b) / 3;
  const brightness = (r + g + b) / 3;
  const saturation = Math.max(r, g, b) - Math.min(r, g, b);
  const distance = Math.sqrt(
    Math.pow(r - bg.r, 2) +
    Math.pow(g - bg.g, 2) +
    Math.pow(b - bg.b, 2)
  );

  return bgBrightness < 42 && brightness < 58 && saturation < 36 && distance < 64;
}

function buildInvertedFile(image, originalFile, callback) {
  const sourceCanvas = buildCanvasFromImage(image);
  const sourceCtx = sourceCanvas.getContext('2d');
  const imageData = sourceCtx.getImageData(0, 0, sourceCanvas.width, sourceCanvas.height);
  const data = imageData.data;
  const bg = sampleCornerBackground(data, sourceCanvas.width, sourceCanvas.height);

  for (let i = 0; i < data.length; i += 4) {
    const alpha = data[i + 3];

    if (alpha < 20) {
      data[i] = 0;
      data[i + 1] = 0;
      data[i + 2] = 0;
      data[i + 3] = 0;
      continue;
    }

    // Se il file è una grafica bianca su fondo nero pieno,
    // il fondo scuro viene rimosso invece di diventare un rettangolo bianco.
    if (isDarkBackgroundPixel(data[i], data[i + 1], data[i + 2], alpha, bg)) {
      data[i] = 0;
      data[i + 1] = 0;
      data[i + 2] = 0;
      data[i + 3] = 0;
      continue;
    }

    data[i] = 255 - data[i];
    data[i + 1] = 255 - data[i + 1];
    data[i + 2] = 255 - data[i + 2];
  }

  sourceCtx.putImageData(imageData, 0, 0);

  const prepared = cropCanvasToContent(sourceCanvas, false);
  canvasToPngFile(prepared.canvas, getInvertedFileName(originalFile), callback);
}

function showInvertedGraphic() {
  bwWarning.style.display = 'block';
  bwWarning.className = 'ngr-success';
  bwWarning.innerHTML = `
    <span class="ngr-success__line">
      <span class="ngr-success__icon"></span>
      <span class="ngr-success__text">
        <span class="ngr-success__title">Grafica invertita</span>
        <span class="ngr-desktop-dash">—</span>
        <span class="ngr-success__subtitle">File aggiornato correttamente</span>
      </span>
    </span>
  `;
}

window.invertGraphic = function() {
  if (!img || !currentFile) {
    alert('Carica prima un file PNG.');
    return;
  }

  if (currentFileKind !== 'png') {
    alert('La funzione Inverti è disponibile solo per file PNG. I PDF vengono verificati prima della produzione.');
    return;
  }

  if (!imageIsBW) {
    alert('Prima rendi monocromatico il PNG, poi puoi invertirlo.');
    return;
  }

  const invertBtn = document.getElementById('ngr-invert-btn');

  if (invertBtn) {
    invertBtn.disabled = true;
    invertBtn.style.opacity = '0.6';
  }

  buildInvertedFile(img, currentFile, function(invertedFile, previewUrl) {
    const invertedImage = new Image();

    invertedImage.onload = function() {
      img = invertedImage;
      currentFile = invertedFile;
      currentFileKind = 'png';
      imageIsBW = true;
      uploadedFileUrl = null;
      imgRatio = invertedImage.naturalHeight / invertedImage.naturalWidth;

      updateCanvasHeight();
      showInvertedGraphic();
      uploadFileToCloudinary(invertedFile);
      drawCanvas();

      if (invertBtn) {
        invertBtn.disabled = false;
        invertBtn.style.opacity = '1';
      }
    };

    invertedImage.onerror = function() {
      alert('Non sono riuscito a invertire la grafica. Prova con un altro PNG.');

      if (invertBtn) {
        invertBtn.disabled = false;
        invertBtn.style.opacity = '1';
      }
    };

    invertedImage.src = previewUrl;
  });
};
/* =========================================================
   09. DISEGNO CANVAS
========================================================= */
function drawCanvas() {
  ctx.setTransform(1, 0, 0, 1, 0, 0);
  ctx.scale(dpr, dpr);
  ctx.clearRect(0, 0, logicalWidth, logicalHeight);

  if (!img) return;

  ctx.save();
  ctx.translate(state.x, state.y);
  ctx.rotate(state.rotation);
  ctx.scale(
    (flippedH ? -1 : 1) * state.scale,
    (flippedV ? -1 : 1) * state.scale
  );

  const drawW = logicalWidth * 0.7;
  const drawH = drawW * imgRatio;

  ctx.drawImage(img, -drawW / 2, -drawH / 2, drawW, drawH);
  ctx.restore();
}

/* =========================================================
   10. TOOLBAR / TRASFORMAZIONI
========================================================= */
function updateCanvasCursor() {
  canvas.classList.remove('cursor-move', 'cursor-moving', 'cursor-scale');

  if (currentTool === 'move') {
    canvas.classList.add(dragging ? 'cursor-moving' : 'cursor-move');
  }

  if (currentTool === 'scale') {
    canvas.classList.add('cursor-scale');
  }
}

document.querySelectorAll('.tool-btn[data-tool]').forEach(function(btn) {
  btn.addEventListener('click', function() {
    currentTool = btn.dataset.tool;

    document.querySelectorAll('.tool-btn[data-tool]').forEach(function(b) {
      b.classList.remove('active');
    });

    btn.classList.add('active');
    updateCanvasCursor();
  });
});

document.querySelector('[data-tool="move"]').classList.add('active');
updateCanvasCursor();

function resetCanvasToDefaultSize() {
  const resetWidth = canvas.parentElement.offsetWidth || logicalWidth || 700;

  resizeCanvas(resetWidth, DEFAULT_CANVAS_HEIGHT);

  state = {
    x: resetWidth / 2,
    y: DEFAULT_CANVAS_HEIGHT / 2,
    scale: 1,
    rotation: 0
  };
}

window.deleteImage = function() {
  img = null;
  uploadedFileUrl = null;
  imageIsBW = false;
  currentFile = null;
  currentFileKind = null;
  uploadToken++;
  fileInput.value = '';
  dropZone.classList.remove('ngr-hidden');
  bwWarning.style.display = 'none';
  sizeWarning.style.display = 'none';
  widthInput.value = '10';
  heightDisplay.value = 'auto';
  flippedH = false;
  flippedV = false;
  resetCanvasToDefaultSize();
  setCartButtonDefault(document.getElementById('add-to-cart-btn'));
  drawCanvas();
  updateSummary();
};

window.flipH = function() {
  flippedH = !flippedH;
  drawCanvas();
};

window.flipV = function() {
  flippedV = !flippedV;
  drawCanvas();
};

window.resetTransform = function() {
  state = {
    x: logicalWidth / 2,
    y: logicalHeight / 2,
    scale: 1,
    rotation: 0
  };

  flippedH = false;
  flippedV = false;

  drawCanvas();
};

/* =========================================================
   11. MOUSE / TOUCH
========================================================= */
function getPos(e) {
  const r = canvas.getBoundingClientRect();

  return {
    x: (e.clientX - r.left) * (logicalWidth / r.width),
    y: (e.clientY - r.top) * (logicalHeight / r.height)
  };
}

function getTouchPos(e) {
  const r = canvas.getBoundingClientRect();

  return {
    x: (e.touches[0].clientX - r.left) * (logicalWidth / r.width),
    y: (e.touches[0].clientY - r.top) * (logicalHeight / r.height)
  };
}

function applyCanvasInteraction(pos) {
  const dx = pos.x - lastMouse.x;
  const dy = pos.y - lastMouse.y;

  if (currentTool === 'move') {
    state.x += dx;
    state.y += dy;
  } else if (currentTool === 'scale') {
    state.scale = Math.max(0.05, state.scale + dy * -0.005);
  } else if (currentTool === 'rotate') {
    state.rotation += dx * 0.01;
  }

  lastMouse = pos;
  drawCanvas();
}

canvas.addEventListener('mousedown', function(e) {
  dragging = true;
  lastMouse = getPos(e);
  updateCanvasCursor();
});

canvas.addEventListener('mouseup', function() {
  dragging = false;
  updateCanvasCursor();
});

canvas.addEventListener('mouseleave', function() {
  dragging = false;
  updateCanvasCursor();
});

canvas.addEventListener('mousemove', function(e) {
  if (!dragging || !img) return;
  applyCanvasInteraction(getPos(e));
});

canvas.addEventListener('touchstart', function(e) {
  dragging = true;
  lastMouse = getTouchPos(e);
  e.preventDefault();
}, { passive: false });

canvas.addEventListener('touchend', function() {
  dragging = false;
});

canvas.addEventListener('touchmove', function(e) {
  if (!dragging || !img) return;
  applyCanvasInteraction(getTouchPos(e));
  e.preventDefault();
}, { passive: false });

/* =========================================================
   12. VARIANTI SHOPIFY / PREZZI
========================================================= */
const variantMap = [
  { maxW: 10,  id: 53772814582101 },
  { maxW: 15,  id: 53770995040597 },
  { maxW: 20,  id: 53770995073365 },
  { maxW: 35,  id: 53770995106133 },
  { maxW: 45,  id: 53770995138901 },
  { maxW: 55,  id: 53770995171669 },
  { maxW: 65,  id: 53770995204437 },
  { maxW: 75,  id: 53770995237205 },
  { maxW: 85,  id: 53770995269973 },
  { maxW: 95,  id: 53770995302741 },
  { maxW: 105, id: 53770995335509 },
  { maxW: 115, id: 53770995368277 },
  { maxW: 125, id: 53770995401045 },
  { maxW: 135, id: 53770995433813 },
  { maxW: 145, id: 53770995466581 },
  { maxW: 155, id: 53770995499349 },
  { maxW: 165, id: 53770995532117 },
  { maxW: 175, id: 53770995564885 },
  { maxW: 185, id: 53770995597653 },
  { maxW: 195, id: 53770995630421 },
  { maxW: 205, id: 53770995663189 },
  { maxW: 215, id: 53770995695957 },
  { maxW: 250, id: 53770995728725 }
];

const priceMap = [10,15,20,30,40,50,60,70,80,90,100,110,120,130,140,150,160,170,180,190,200,210,220];

function getVariant(wCm, hCm) {
  let idx = variantMap.findIndex(function(v) {
    return wCm <= v.maxW;
  });

  if (idx === -1) idx = variantMap.length - 1;
  if (hCm && parseFloat(hCm) <= 5 && idx > 0) idx -= 1;

  return {
    id: variantMap[idx].id,
    price: priceMap[idx]
  };
}

function updateSummary() {
  if (!priceEstimate || !summaryDetails) return;

  if (!img) {
    priceEstimate.textContent = 'CHF 0.-';
    summaryDetails.textContent = 'Carica un file per calcolare il prezzo';
    return;
  }

  const wCm = parseFloat(widthInput.value) || 10;
  const hValue = heightDisplay.value && heightDisplay.value !== '—' ? heightDisplay.value : 'auto';
  const parsedH = parseFloat(hValue);
  const colore = document.getElementById('colore-selezionato').value || 'Scegli colore/finitura';
  const variant = getVariant(wCm, parsedH);

  priceEstimate.textContent = 'CHF ' + variant.price + '.-';
  summaryDetails.textContent = fmt(wCm) + ' x ' + hValue + ' cm · ' + colore;
}

updateSummary();

function showConfigMessage(message, type) {
  if (!configMessage) {
    console.warn(message);
    return;
  }

  configMessage.textContent = message;
  configMessage.className = 'ngr-config-message ngr-config-message--' + (type || 'error') + ' is-visible';
}

function clearConfigMessage() {
  if (!configMessage) return;

  configMessage.textContent = '';
  configMessage.className = 'ngr-config-message';
}


function flashUploadRequired() {
  const btn = document.getElementById('add-to-cart-btn');
  const originalHtml = btn.innerHTML;

  dropZone.classList.add('ngr-upload-needed');
  btn.classList.add('ngr-cart-btn-error');
  btn.innerHTML = 'Carica prima un file';

  window.clearTimeout(btn._ngrUploadRequiredTimer);
  btn._ngrUploadRequiredTimer = window.setTimeout(function() {
    dropZone.classList.remove('ngr-upload-needed');
    btn.classList.remove('ngr-cart-btn-error');
    if (!img) {
      setCartButtonDefault(btn);
    } else {
      btn.innerHTML = originalHtml;
    }
  }, 1700);
}

function getProductionNote() {
  const noteInput = document.getElementById('production-note-input');

  if (!noteInput) return '';

  return noteInput.value
    .replace(/[\r\n]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 220);
}

function prepareMobileBeforeCartAdd() {
  const active = document.activeElement;

  if (active && typeof active.blur === 'function') {
    active.blur();
  }

  const noteDetails = document.getElementById('ngr-production-note');

  if (noteDetails && noteDetails.open && window.matchMedia('(max-width: 720px)').matches) {
    noteDetails.open = false;
  }
}

/* =========================================================
   13. ADD TO CART
========================================================= */
document.getElementById('add-to-cart-btn').addEventListener('click', function() {
  clearConfigMessage();

  if (!img) {
    flashUploadRequired();
    return;
  }

  prepareMobileBeforeCartAdd();
  
  if (fileBlockedForCut) {
    alert('Il file contiene sfumature, ombre o dettagli fotografici e non è adatto al taglio. Carica un logo PNG pulito o un PDF vettoriale.');
    return;
  }

  if ((currentFileKind === 'png' || currentFileKind === 'jpg') && !imageIsBW) {
    alert('File a colori rilevato. Usa “Rendi monocromatico” prima di aggiungerlo al carrello.');
    return;
  }

  if (!uploadedFileUrl) {
    alert('Il file è ancora in caricamento. Attendi qualche secondo e riprova.');
    return;
  }

  const colore = document.getElementById('colore-selezionato').value;

  if (!colore) {
    showColorError();
    return;
  }

  const wCm = parseFloat(widthInput.value);
  const hCm = heightDisplay.value;

  if (!wCm || wCm < 1) {
    alert('Inserisci una larghezza valida in centimetri.');
    return;
  }

  const variant = getVariant(wCm, parseFloat(hCm));
  const productionNote = getProductionNote();

  const lineProperties = {
    'Larghezza (cm)': wCm,
    'Altezza (cm)': hCm || 'auto',
    'Colore': colore,
    '_File immagine': uploadedFileUrl
  };

  if (productionNote) {
    lineProperties['Note produzione'] = productionNote;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: [{
        id: variant.id,
        quantity: 1,
        properties: lineProperties
      }]
    })
  })
  .then(function(r) {
    return r.json();
  })
  .then(function(data) {
    if (data.status) {
      alert('Non sono riuscito ad aggiungere il prodotto: ' + data.description);
    } else {
      createCartPopup(wCm, hCm, colore, variant.price);
    }
  })
  .catch(function() {
    alert('Errore di rete. Controlla la connessione e riprova.');
  });
});

function showColorError() {
  const btn = document.getElementById('color-dropdown-btn');

  btn.classList.add('ngr-color-error-active');

  btn.classList.remove('color-shake-error');
  void btn.offsetWidth;
  btn.classList.add('color-shake-error');

  btn.addEventListener('mouseenter', function clearColorError() {
    btn.classList.remove('ngr-color-error-active');
    btn.classList.remove('color-shake-error');
    btn.removeEventListener('mouseenter', clearColorError);
  });
}

/* =========================================================
   14. POPUP CARRELLO
========================================================= */
function createCartPopup(wCm, hCm, colore, price) {
  const popup = document.createElement('div');
  popup.id = 'ngr-cart-popup';
  popup.style.cssText = `
    position:fixed;
    inset:0;
    width:100%;
    height:100%;
    background:rgba(0,0,0,.62);
    backdrop-filter:blur(14px) saturate(140%);
    -webkit-backdrop-filter:blur(14px) saturate(140%);
    z-index:9999;
    display:flex;
    align-items:center;
    justify-content:center;
    padding:18px;
  `;

  const box = document.createElement('div');
  box.style.cssText = `
    position:relative;
    width:min(92vw, 390px);
    padding:34px 24px 24px;
    border:1px solid rgba(255,255,255,.16);
    border-radius:28px;
    background:
      radial-gradient(circle at 18% 0%, rgba(255,255,255,.16), transparent 34%),
      radial-gradient(circle at 88% 10%, rgba(26,115,232,.18), transparent 28%),
      linear-gradient(145deg, rgba(35,35,38,.92), rgba(13,13,15,.96));
    color:#f5f5f7;
    box-shadow:0 24px 70px rgba(0,0,0,.55), inset 0 1px 0 rgba(255,255,255,.12);
    backdrop-filter:blur(24px) saturate(160%);
    -webkit-backdrop-filter:blur(24px) saturate(160%);
    text-align:center;
    overflow:hidden;
  `;

  const closeBtn = createPopupCloseButton(popup);
  const checkWrap = createPopupCheckIcon();
  const title = createPopupTitle('Aggiunto al carrello');
  const subtitle = createPopupSubtitle('Il tuo adesivo personalizzato è stato salvato.');
  const table = createPopupTable(wCm, hCm, colore, price);
  const buttons = createPopupButtons(popup);

  box.appendChild(closeBtn);
  box.appendChild(checkWrap);
  box.appendChild(title);
  box.appendChild(subtitle);
  box.appendChild(table);
  box.appendChild(buttons);

  popup.appendChild(box);
  document.body.appendChild(popup);

  popup.addEventListener('click', function(e) {
    if (e.target === popup) popup.remove();
  });
}

function createPopupCloseButton(popup) {
  const closeBtn = document.createElement('button');
  closeBtn.innerHTML = '&times;';
  closeBtn.style.cssText = `
    position:absolute;
    top:14px;
    right:16px;
    width:34px;
    height:34px;
    display:flex;
    align-items:center;
    justify-content:center;
    background:rgba(255,255,255,.08);
    border:1px solid rgba(255,255,255,.12);
    border-radius:999px;
    color:rgba(255,255,255,.68);
    font-size:24px;
    cursor:pointer;
    line-height:1;
    padding:0;
    transition:background .18s ease, color .18s ease, transform .18s ease;
  `;

  closeBtn.addEventListener('mouseover', function() {
    this.style.background = 'rgba(255,255,255,.14)';
    this.style.color = '#fff';
    this.style.transform = 'translateY(-1px)';
  });

  closeBtn.addEventListener('mouseout', function() {
    this.style.background = 'rgba(255,255,255,.08)';
    this.style.color = 'rgba(255,255,255,.68)';
    this.style.transform = '';
  });

  closeBtn.addEventListener('click', function() {
    popup.remove();
  });

  return closeBtn;
}

function createPopupCheckIcon() {
  const checkWrap = document.createElement('div');
  checkWrap.style.cssText = 'display:flex;justify-content:center;margin-bottom:14px;';
  checkWrap.innerHTML = `
    <div style="
      width:76px;
      height:76px;
      border-radius:999px;
      display:flex;
      align-items:center;
      justify-content:center;
      background:linear-gradient(135deg, rgba(51,204,51,.18), rgba(255,255,255,.06));
      border:1px solid rgba(51,204,51,.34);
      box-shadow:0 14px 34px rgba(51,204,51,.12), inset 0 1px 0 rgba(255,255,255,.14);
    ">
      <svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 72 72">
        <circle cx="36" cy="36" r="28" fill="none" stroke="#33cc33" stroke-width="3.5"
          style="stroke-dasharray:176;stroke-dashoffset:176;animation:ngrCircle 0.5s ease forwards;"/>
        <polyline points="22,37 32,48 51,26" fill="none" stroke="#33cc33" stroke-width="5"
          stroke-linecap="round" stroke-linejoin="round"
          style="stroke-dasharray:45;stroke-dashoffset:45;animation:ngrCheck 0.4s ease 0.45s forwards;"/>
      </svg>
    </div>
    <style>
      @keyframes ngrCircle { to { stroke-dashoffset: 0; } }
      @keyframes ngrCheck { to { stroke-dashoffset: 0; } }
    </style>
  `;

  return checkWrap;
}

function createPopupTitle(text) {
  const title = document.createElement('div');
  title.style.cssText = `
    font-size:29px;
    font-weight:800;
    color:#fff;
    margin-bottom:6px;
    letter-spacing:-.04em;
  `;
  title.textContent = text;
  return title;
}

function createPopupSubtitle(text) {
  const subtitle = document.createElement('div');
  subtitle.style.cssText = `
    font-size:13px;
    font-weight:500;
    color:rgba(255,255,255,.58);
    margin-bottom:20px;
  `;
  subtitle.textContent = text;
  return subtitle;
}

function createPopupTable(wCm, hCm, colore, price) {
  const table = document.createElement('div');
  table.style.cssText = `
    border:1px solid rgba(255,255,255,.12);
    border-radius:18px;
    overflow:hidden;
    margin-bottom:20px;
    font-size:14px;
    text-align:left;
    background:linear-gradient(135deg, rgba(255,255,255,.10), rgba(255,255,255,.045));
    box-shadow:inset 0 1px 0 rgba(255,255,255,.10);
  `;

  table.appendChild(createPopupRow('Dimensioni', wCm + ' x ' + (hCm || 'auto') + ' cm', false));
  table.appendChild(createPopupRow('Colore', colore, false));
  table.appendChild(createPopupRow('Prezzo totale', 'CHF ' + price + '.-', true));
  table.lastChild.style.borderBottom = 'none';

  return table;
}

function createPopupRow(label, value, bigValue) {
  const row = document.createElement('div');
  row.style.cssText = `
    display:flex;
    align-items:center;
    justify-content:space-between;
    gap:14px;
    padding:13px 15px;
    border-bottom:1px solid rgba(255,255,255,.10);
  `;

  const lbl = document.createElement('div');
  lbl.style.cssText = `
    color:rgba(255,255,255,.50);
    font-weight:750;
    font-size:11px;
    text-transform:uppercase;
    letter-spacing:.08em;
  `;
  lbl.textContent = label;

  const val = document.createElement('div');
  val.style.cssText = `
    color:${bigValue ? '#ffffff' : 'rgba(255,255,255,.90)'};
    font-size:${bigValue ? '20px' : '14px'};
    font-weight:${bigValue ? '850' : '650'};
    text-align:right;
    white-space:nowrap;
  `;
  val.textContent = value;

  row.appendChild(lbl);
  row.appendChild(val);

  return row;
}

function createPopupButtons(popup) {
  const btnRow = document.createElement('div');
  btnRow.style.cssText = `
    display:grid;
    grid-template-columns:1fr 1fr;
    gap:10px;
    align-items:stretch;
  `;

  const btnContinue = document.createElement('button');
  btnContinue.style.cssText = `
    width:100%;
    min-height:46px;
    padding:12px 10px;
    background:linear-gradient(135deg, rgba(255,255,255,.13), rgba(255,255,255,.055));
    color:rgba(255,255,255,.88);
    border:1px solid rgba(255,255,255,.13);
    border-radius:14px;
    cursor:pointer;
    font-size:13px;
    font-weight:650;
    display:flex;
    align-items:center;
    justify-content:center;
    transition:background .18s ease, transform .18s ease, color .18s ease;
  `;
  btnContinue.textContent = 'Continua a personalizzare';

  btnContinue.addEventListener('mouseover', function() {
    this.style.background = 'linear-gradient(135deg, rgba(255,255,255,.20), rgba(255,255,255,.08))';
    this.style.color = '#fff';
    this.style.transform = 'translateY(-1px)';
  });

  btnContinue.addEventListener('mouseout', function() {
    this.style.background = 'linear-gradient(135deg, rgba(255,255,255,.13), rgba(255,255,255,.055))';
    this.style.color = 'rgba(255,255,255,.88)';
    this.style.transform = '';
  });

  btnContinue.addEventListener('click', function() {
    popup.remove();
  });

  const btnCart = document.createElement('button');
  btnCart.style.cssText = `
    width:100%;
    min-height:46px;
    padding:12px 10px;
    background:linear-gradient(135deg, #1A73E8, #4A90E8);
    color:#fff;
    border:1px solid rgba(255,255,255,.20);
    border-radius:14px;
    cursor:pointer;
    font-size:13px;
    font-weight:750;
    display:flex;
    align-items:center;
    justify-content:center;
    gap:6px;
    white-space:nowrap;
    box-shadow:0 12px 28px rgba(26,115,232,.25), inset 0 1px 0 rgba(255,255,255,.22);
    transition:background .18s ease, transform .18s ease, box-shadow .18s ease;
  `;
  btnCart.innerHTML = 'Vai al carrello<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  btnCart.addEventListener('mouseover', function() {
    this.style.background = 'linear-gradient(135deg, #3284ed, #5b9bf0)';
    this.style.transform = 'translateY(-1px)';
    this.style.boxShadow = '0 16px 34px rgba(26,115,232,.32), inset 0 1px 0 rgba(255,255,255,.25)';
  });

  btnCart.addEventListener('mouseout', function() {
    this.style.background = 'linear-gradient(135deg, #1A73E8, #4A90E8)';
    this.style.transform = '';
    this.style.boxShadow = '0 12px 28px rgba(26,115,232,.25), inset 0 1px 0 rgba(255,255,255,.22)';
  });

  btnCart.addEventListener('click', function() {
    window.location.href = '/cart';
  });

  btnRow.appendChild(btnContinue);
  btnRow.appendChild(btnCart);

  return btnRow;
}

/* =========================================================
   15. COLOR DROPDOWN
========================================================= */
window.toggleColorDropdown = function() {
  const menu = document.getElementById('color-dropdown-menu');
  menu.style.display = menu.style.display === 'none' ? 'block' : 'none';
};

window.selectColor = function(name, hex) {
  const btn = document.getElementById('color-dropdown-btn');

  document.getElementById('color-preview').style.setProperty('background', hex, 'important');
  document.getElementById('color-label').textContent = name;
  document.getElementById('colore-selezionato').value = name;
  document.getElementById('color-dropdown-menu').style.display = 'none';

  btn.style.background = '';
  btn.style.boxShadow = '';
  btn.style.borderColor = '';
  btn.classList.remove('color-shake-error');
  btn.classList.remove('ngr-color-error-active');
  updateSummary();
};

document.addEventListener('click', function(e) {
  const btn = document.getElementById('color-dropdown-btn');
  const menu = document.getElementById('color-dropdown-menu');

  if (!btn.contains(e.target) && !menu.contains(e.target)) {
    menu.style.display = 'none';
  }
});

})();
